import React, { Fragment } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { receive_register_error } from "../../apis/redux/fetchActions";
import {
    Button, Dialog, DialogTitle, DialogContent,
    Checkbox,
    CircularProgress,
    IconButton,
    Link,
    Paper,
    TextField,
    Typography,
    withStyles
} from '@material-ui/core'
import { NavigateBefore } from '@material-ui/icons'
import { logoFull } from "../../resources/images";
import APIService from "../../apis/amplify/APIService";
import formHandlerHOC, { buildSyntheticEvent, isInvalidField } from '../../components/FormHandlerHOC';
import Fvt from '../../components/FieldValidationText';
import If from "../../components/If";
import { errorBundaryHOC } from "../../components/ErrorBoundary";
import FieldInfo from "../../components/FieldInfo";
import { formatPhone } from '../../util/formatters';
import { emailInvalidText } from '../../util/texts';
import { styles } from './styles';

class Register extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            requestInProgress: false,
            showTerms: false,
            loadingTerms: true,
            termsAndConditionsAccepted: false,
            termsAndConditions: null,
            showPassFieldInfo: false
        };
    }

    handleSubmit = async event => {
        event.preventDefault();
        const {
            history, receiveRegisterError, validateForm, getFormData, getFormStateSync, invalidateField
        } = this.props;
        validateForm();
        const { isValid, ...rest } = getFormStateSync();

        if (isValid) {
            const { name, surnames, email, phone, password } = getFormData(rest);

            this.setState({ requestInProgress: true });
            const payload = {
                email: email,
                password: password,
                phone_number: phone,
                first_name: name,
                last_name: surnames
            };
            const { ok, data } = await APIService.signUp(payload);
            this.setState({ requestInProgress: false });
            if (ok) {
                history.replace(`/login/${email}`);
            } else {
                const { code, field } = data;
                const fieldNameMap = {
                    email: 'email',
                    phone_number: 'phone'
                };
                if (code === 400) {
                    invalidateField(fieldNameMap[field], payload[field],
                        `There is a user with this ${fieldNameMap[field]} already registered.`);
                } else {
                    receiveRegisterError('We had an unexpected problem. Please try again later.');
                }
            }
        }
    };

    onLogin = event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        this.props.history.replace('/login');
    };

    async showTerms(event) {
        event.stopPropagation();
        this.setState({ showTerms: true });
        if (!this.state.termsAndConditions) {
            this.setState({ loadingTerms: true });
            try {
                const response = await APIService.getAppConfig();
                this.setState({ termsAndConditions: response.mobile_terms_and_conditions, loadingTerms: false })
            } catch (e) {
                //ignore
            }
        }
    }

    goToHome() {
        this.props.history.replace('/home');
    }

    render() {
        const {
            classes,
            onFormChange,
            formState: {
                isValid, isPristine, name, surnames, email, phone, password, password_confirmation
            }
        } = this.props;
        const {
            requestInProgress, termsAndConditionsAccepted,
            showTerms, loadingTerms, termsAndConditions, showPassFieldInfo
        } = this.state;

        return (
            <Fragment>

                <Dialog open={showTerms}
                        disableBackdropClick={false}
                        onBackdropClick={() => {
                            this.setState({ showTerms: false })
                        }}>
                    <DialogTitle disableTypography>
                        <Typography variant="h5" className={classes.signInText}>
                            Terms & Conditions
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <If as={'div'} condition={loadingTerms}>
                            <div style={{
                                flexDirection: 'column',
                                alignItems: 'center',
                                display: 'flex',
                                padding: '70px'
                            }}>
                                <CircularProgress/>
                            </div>
                        </If>
                        <If condition={!!termsAndConditions}>
                            <div style={{ padding: '5px' }}>
                                <p style={{ whiteSpace: 'pre-wrap', }}>{termsAndConditions}</p>
                            </div>
                        </If>
                    </DialogContent>
                </Dialog>

                <div className={classes.backgroundDiv}>
                    <div className={classes.logoDiv}>
                        <img src={logoFull} alt='' className={classes.logoImage}
                             onClick={this.goToHome.bind(this)}/>
                    </div>
                </div>

                <div className={classes.main}>
                    <Paper className={classes.paper}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <IconButton onClick={this.onLogin} className={classes.backButton}>
                                <NavigateBefore/>
                            </IconButton>
                            <Typography component="h1" variant="h5" align='center' style={{ flexGrow: 0.7 }}>
                                New Account
                            </Typography>
                        </div>

                        <form className={classes.form} onSubmit={this.handleSubmit}>
                            <TextField value={name.value}
                                       onChange={onFormChange}
                                       error={isInvalidField(name)}
                                       name="name"
                                       label='Name' required autoComplete="name"
                                       margin="normal" fullWidth autoFocus/>
                            <Fvt>{name.primaryMessage}</Fvt>

                            <TextField value={surnames.value}
                                       onChange={onFormChange}
                                       error={isInvalidField(surnames)}
                                       name="surnames"
                                       label='Last Name'
                                       autoComplete="surnames" margin="normal" fullWidth/>
                            <Fvt>{surnames.primaryMessage}</Fvt>

                            <TextField value={email.value}
                                       onChange={onFormChange}
                                       error={isInvalidField(email)}
                                       name="email"
                                       label='Email' required type='email' autoComplete="email"
                                       margin="normal" fullWidth/>
                            <Fvt>{email.primaryMessage}</Fvt>

                            <TextField value={phone.value}
                                       onChange={onFormChange}
                                       onBlur={() => onFormChange(buildSyntheticEvent(formatPhone(phone.value), 'phone'))}
                                       error={isInvalidField(phone)}
                                       name="phone"
                                       placeholder="(###) ###-####"
                                       label='Phone Number' required type='phone' autoComplete="phone"
                                       margin="normal" fullWidth/>
                            <Fvt>{phone.primaryMessage}</Fvt>

                            <TextField value={password.value}
                                       onChange={onFormChange}
                                       onFocus={() => this.setState({ showPassFieldInfo: true })}
                                       onBlur={() => this.setState({ showPassFieldInfo: false })}
                                       error={isInvalidField(password)}
                                       name="password"
                                       label='Password' required type='password'
                                       autoComplete="new-password" margin="normal" fullWidth/>
                            <If as={FieldInfo} condition={showPassFieldInfo}>
                                Should have more than 6 characters, at least one letter and number
                            </If>
                            <Fvt>{password.primaryMessage}</Fvt>

                            <TextField value={password_confirmation.value}
                                       onChange={onFormChange}
                                       error={isInvalidField(password_confirmation)}
                                       name="password_confirmation"
                                       label='Confirm Password' required type='password'
                                       autoComplete="new-password" margin="normal" fullWidth/>
                            <Fvt>{password_confirmation.primaryMessage}</Fvt>

                            <div className={classes.checkContainer}>
                                <Checkbox checked={termsAndConditionsAccepted}
                                          style={{ paddingLeft: 0 }}
                                          onChange={() => this.setState({ termsAndConditionsAccepted: !termsAndConditionsAccepted })}
                                          color="secondary"/>
                                <span className="checkLabel">You must accept the <Link
                                    style={{ cursor: 'pointer' }} color='secondary'
                                    underline='always' onClick={this.showTerms.bind(this)}>Terms and Conditions</Link> to continue.</span>
                            </div>

                            <Typography color="error" align="center">
                                {this.props.registerErrorText}
                            </Typography>

                            <Button
                                disabled={!isValid || isPristine || requestInProgress || !termsAndConditionsAccepted}
                                fullWidth
                                variant="contained"
                                color="secondary"
                                className={classes.registerButton}
                                type='submit'>
                                Create Account
                                <If as={CircularProgress} condition={requestInProgress} size={20}/>
                            </Button>

                        </form>
                    </Paper>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        registerErrorText: state.registerErrorText,
    }
};

const mapDispatchToProps = dispatch => (
    {
        actions: bindActionCreators({
            receiveRegisterError: receive_register_error
        }, dispatch)
    }
);

let RegisterWarpped = formHandlerHOC({
    rules: {
        name: 'required',
        surnames: 'required',
        email: 'required|email',
        phone: 'required|us_phone',
        password_confirmation: 'required',
        password: 'required|confirmed|min:6|contains_alpha_numeric',
    },
    validationMessages: {
        required: 'Required',
        email: emailInvalidText,
        min: 'The password must contain at least 6 characters',
        confirmed: 'The password and the confirmation must match',
        contains_alpha_numeric: 'The password should contain at least one letter and one number',
    }
})(Register);
RegisterWarpped = withStyles(styles)(RegisterWarpped);
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC(RegisterWarpped));
